// import {Actions} from 'react-native-router-flux';
import _ from 'lodash';

import user from '../../apis/user';
import * as types from '../constants/ActionTypes';

// ex) state를 받아둔다음, 초기화 dispatch를 날려 state를 비운다.의 로직인것같음
// const {cart} = getState();
// dispatch({
//   type: types.CHECKOUT_REQUEST
// });

const receiveUserInfo = userInfo => ({
  type: types.RECEIVE_USERINFO,
  userInfo,
});

// RECEIVE_USER_EXERCISE 타입으로 급파보낸다 > reducer 작동
// userReducer의 const userExercises대로 처리를 시작하겠지
const receiveUserExercises = userExercises => ({
  type: types.RECEIVE_USER_EXERCISE,
  userExercises,
});

const receiveUserExerciseDurations = userExerciseDurations => ({
  type: types.RECEIVE_USER_EXER_DURATION,
  userExerciseDurations,
});

// dispatch(action)으로 액션을 급파보낸다 > reducer 작동
export const getUser = () => async dispatch => {
  try {
    const result = await user.getUserInfo();

    dispatch(receiveUserInfo(result.data.data));

    return result;
  } catch (e) {
    throw e;
  }
};

export const saveUser = (description, instagram, naverBlog) => async dispatch => {
  try {
    const result = await user.saveUserInfo(description, instagram, naverBlog);
    return result;
  } catch(e) {
    throw e;
  }
}



export const getUserExercises = () => async dispatch => {
  try {
    const result = await user.getUserExercises();

    dispatch(receiveUserExercises(result.data.data.exercises));
    dispatch(receiveUserExerciseDurations(result.data.data.exerciseDurations));
    // dispatch(duration);
  } catch (e) {
    console.log(e);
  }
};

export const addUserExercise = exerciseId => async (dispatch, getState) => {
  try {
    const result = await user.postUserExerciseAdd(exerciseId);
    // console.log('postUserExerciseAdd: ', result);

    dispatch(receiveUserExercises(result.data.data.exercises));
    dispatch(receiveUserExerciseDurations(result.data.data.exerciseDurations));
  } catch (e) {
    console.log(e);
  }
};

export const removeUserExercise = exerciseId => async (dispatch, getState) => {
  try {
    const result = await user.postUserExerciseRemove(exerciseId);
    // console.log('postUserExerciseRemove: ', result);

    dispatch(receiveUserExercises(result.data.data.exercises));
    dispatch(receiveUserExerciseDurations(result.data.data.exerciseDurations));
  } catch (e) {
    console.log(e);
  }
};

// export const removeUserExercise = exerciseId => (dispatch, getState) => {
//   // 서버에서 요청한다, userExercise 받아올것임
//   user.postUserExerciseAdd(exerciseId, userExercises => {
//     dispatch({
//       type: types.RECEIVE_USER_EXERCISE,
//       userExercises,
//     });
//   });
// };

export const addUserExerciseDuration = exerciseId => async dispatch => {
  try {
    const result = await user.postUserExerciseDuration(exerciseId);
    // console.log('postUserExerciseDuration: ', result.data);

    dispatch(receiveUserExercises(result.data.data.exercises));
    dispatch(receiveUserExerciseDurations(result.data.data.exerciseDurations));
  } catch (e) {
    console.log(e);
  }
};
